import { resetOrderData, selectAdressInfos } from '@features/eligibility/eligibilitySlice';
import { loadSite } from '@features/siteStatusV2/reducer/siteSlice';
import theme from '@theme';
import React, { useEffect, useRef, useState } from 'react';
import { Card } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { RootState } from '../../../../app/store';
import AddressInformations from './AddressInformations';
import IdentityHeader from './IdentityHeader';
import SiteInformations from './SiteInformations';
import VerticalityForm from './VerticalityForm';

const IdentityCard: React.FC = () => {
  const dispatch = useAppDispatch();
  const addressInfos = useAppSelector(selectAdressInfos);
  const { site } = useSelector((state: RootState) => state.site);
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const hasClickedRef = useRef(false);
  const accordionToggleRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (addressInfos?.buildingRef) {
      dispatch(loadSite({ addressInfos }));
    }
  }, [addressInfos]);

  useEffect(() => {
    return () => {
      dispatch(resetOrderData());
    };
  }, [dispatch]);

  useEffect(() => {
    if (site?.buildings.length === 0 && !hasClickedRef.current && accordionToggleRef.current) {
      accordionToggleRef.current.click();
      hasClickedRef.current = true;
    }
  }, [site]);

  return (
    <Accordion defaultActiveKey="0" flush>
      <CustomCard>
        <IdentityHeader
          accordionToggleRef={accordionToggleRef}
          addressInfos={addressInfos}
          isAccordionOpen={isAccordionOpen}
        />
        <Accordion.Collapse
          eventKey="0"
          onEnter={() => setIsAccordionOpen(true)}
          onExit={() => setIsAccordionOpen(false)}
        >
          <Card.Body className="px-4 py-2">
            <AddressInformations />
            <SiteInformations />
            <Br />
            <VerticalityForm />
          </Card.Body>
        </Accordion.Collapse>
      </CustomCard>
    </Accordion>
  );
};

const Br = styled.div`
  height: 1px;
  width: 90%;
  margin: 30px auto;
  background-color: ${theme.palette.grey[200]};
`;

const CustomCard = styled(Card)`
  background-color: ${theme.palette.grey[50]};
  border: none;
  box-shadow: none;
`;
export default IdentityCard;
